import type {
	DesignerCompetency,
	DesignerEducation,
	DesignerExperienceLevel,
} from "@/types/user";

export const DESIGNER_EXPERIENCE_LEVELS = [
	{
		value: "Creative Professional",
		label: "Creative Professional",
		description:
			"You have been working as a product/industrial designer for a minimum of 5-7 years with a track record of projects and direct engagements with buyers/clients.",
	},
	{
		value: "Creative Graduate",
		label: "Creative Graduate",
		description:
			"You have recently graduated with a bachelor or masters degree in product/industrial design.",
	},
	{
		value: "Creative Student",
		label: "Creative Student",
		description:
			"You are currently studying to obtain a bachelor or masters degree within the field of product/industrial design.",
	},
	{
		value: "Other",
		label: "Other",
		description: "(None of the above matched my profile)",
	},
] satisfies {
	value: DesignerExperienceLevel;
	label: string;
	description: string;
}[];

export const DESIGNER_COMPETENCIES: readonly {
	value: DesignerCompetency;
	label: string;
}[] = [
	{
		value: "PRODUCT_DESIGN",
		label: "Product design",
	},
	{
		value: "FASHION_AND_TEXTILE_DESIGN",
		label: "Fashion and textile design",
	},
	{
		value: "PACKAGING_DESIGN",
		label: "Packaging design",
	},
	{
		value: "SPATIAL_DESIGN",
		label: "Spatial design",
	},
] as const;

export const DESIGNER_EDUCATIONS: readonly {
	value: DesignerEducation;
	label: string;
}[] = [
	{
		value: "bachelor",
		label: "Bachelor's degree",
	},
	{
		value: "master",
		label: "Master's degree",
	},
	{
		value: "doctoral",
		label: "Doctoral degree",
	},
] as const;
